<i18n>
{
  "en": {
      "title": "Temperature trend",
      "subTitle": "Graph relating to the trend of the temperature detected by the sensor in the selected time period."

  },
  "it": {
      "title": "Andamento delle temperature",
      "subTitle": "Grafico relativo all’andamento della temperatura rilevata dal sensore nel periodo di tempo selezionato."
  }
}
</i18n>

<template>
  <BalloonTemplate arrowDirection="left" id="root" :visible="visible" @close="$emit('close')">
    <template v-slot:header>
      <h1>{{ $t("title") }}</h1>
    </template>
    <template v-slot:content>
      <p>{{ $t("subTitle") }}</p>
    </template>
  </BalloonTemplate>
</template>
<script>
import BalloonTemplate from "../../BallonTemplate.vue";

export default {
  name: "temperatureDeckBalloon",
  components: {
    BalloonTemplate,
  },
  props: {
    visible: Boolean,
  },
};
</script>
<style scoped>
#root {
  width: 360px;
}
</style>
